import { useState } from "react"
import { homes } from "../../data/data"

export default function Homes() {
  const [houses] = useState(homes)

  return (
    <>
      <section className="max-width py-10 xl:py-20">
        <h2 className="heading-2 mb-5 xl:mb-10">Available Homes</h2>

        <div className="grid grid-cols-1 gap-10 lg:gap-0">
          {houses.map(({ id, image, title, desc }) => (
            <article
              key={id}
              className="homes-article lg:grid grid-cols-2 gap-5 lg:items-center lg:gap-0"
            >
              <div className="one">
                <img
                  src={image}
                  alt={title}
                  className="rounded-t lg:rounded-none"
                />
              </div>

              <div className="two">
                <h3 className="heading-2 mb-1 mt-5 lg:mt-0 xl:mb-5">{title}</h3>
                <p className="gray">{desc}</p>
                <button className="btn-light mt-3 xl:mt-5">Book a demo</button>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  )
}
